"use client"

import { useAllSupporters } from "@/hooks/coins/useSupporters"
import { SupportersResp } from "@/types/coins"
import SupporterTable from "./SupporterTable"

type Props = {
  initialData: SupportersResp | undefined
  coinId: string
}

export function AllSupportersTable({ initialData, coinId }: Props) {
  const { allSupporters } = useAllSupporters({ initialData, coinId })

  if (!allSupporters) return null

  return <SupporterTable supporters={allSupporters} isMinimal />
}
